<template>
	<div>
		<v-switch
			:class="'switch-display'"
			hide-details
			v-bind="$attrs"
			v-model="value"
			@change="$emit('on-switch-change', { model: model, value: $event })"
		></v-switch>
	</div>
</template>

<script>
	function created() {
		this.value = this.modelValue;
	}

	function data() {
		return {
			value: null,
		};
	}

	export default {
		name: 'switch-display',
		created,
		data,
		inheritAttrs: false,
		props: {
			model: String,
			modelValue: [String, Number],
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/market-place/switch-display.vue